<template>
  <div class="modal fade in modal-open" @click.self.stop="closeModal" v-if="isModalOpen">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal__header modal__vendor--header modal__header--vendor-bg">
          <div class="modal__header--angles">
            <div class="modal__close-btn">
              <i class="fa fa-times" @click.self.stop="closeModal"></i>
            </div>
            <img class="modal__vendor--logo" :src="modalData.logoURL">
            <button @click.stop="downloadOverview" class="modal__download-btn" v-if="modalData.overviewURL">Download vendor PDF</button>
            <div class="modal__no-file" v-else>Sorry, no file available!</div>
          </div>
        </div>
        <div class="modal__body">
          <div class="container-fluid">
            <div class="modal__contact-row modal__contact-row--doc">
              <div class="modal__contact-msg-box--doc" v-show="modalData">
                <div class="modal__contact-msg-box">
                  <div class="col-sm-12">
                    <img class="modal__profile-pic--vendor" :src="rm.headshot">
                    Please contact your Regional Manager for more information about this service.
                  </div>
                </div>
              </div>
            </div>
            <div class="modal__form-placeholder" v-if="fuelEmployee" @click="closeModal">Only members can send messages to RMs.</div>
            <form name="getContractInfo" id="getContractInfo" v-else>
              <div class="modal__contact-row">
                <div class="col-sm-12">
                  <textarea
                      class="modal__comment-block modal__comment-block--vendor"
                      name="message"
                      placeholder="Message"
                      v-model="text"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal__footer">
          <div class="modal__sending-overlay" v-if="isSending">
            <MoonLoader size="25px" color="#1176BB"></MoonLoader>
          </div>
          <div class="modal__send-btn" @click.stop="sendMessage" v-else>Send&nbsp;<span class="glyphicon glyphicon-send" aria-hidden="true"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelUtilities from "../../utils/FuelUtilities";
  import MoonLoader from 'vue-spinner/dist/vue-spinner.min';

  export default {
    name: 'VendorModal',
    mixins: [FuelUtilities],
    components: {
      MoonLoader,
    },
    data() {
      return {
        text: '',
      };
    },
    props: {
      modalKey: '',
      headerClass: '',
    },
    mounted() {
      const component = this;
      this.handler = function (e) {
        if (e.code === 'Escape') {
          component.closeModal();
        }
      }
      window.addEventListener('keyup', this.handler);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.handler);
    },
    computed: {
      ...mapGetters('main', ['displayedModal', 'modalData', 'loaders', 'rm']),
      fuelEmployee() {
        return false;
      },
      isModalOpen() {
        return this.displayedModal === this.modalKey;
      },
      headerClasses() {
        return `modal__header--${this.headerClass}`;
      },
      isSending() {
        return this.loaders.sendingMessage;
      },
    },
    methods: {
      /**
       *  Sends message from member to the back-end server.
       */
      async sendMessage() {
        if (this.text) {
          await this.$store.dispatch('main/sendMessage', {
            title: `Vendor Inquiry: ${this.modalData.name}`,
            message: this.text,
            email: this.rm.email,
          });
          this.closeModal();
        }
      },
      downloadOverview() {
        if (this.modalData.overviewURL != "") {
          window.location = this.decode(this.modalData.overviewURL);
        }
      },
      closeModal() {
        this.$store.dispatch('main/showModal', null);
      },
    },
  };
</script>
